<template lang="pug">
  .root
    ArchiveBase(:liveType="liveType")

</template>

<style src="./ArchivePaid.scss" lang="scss" scoped>

</style>

<script>
import ArchiveBase from './components/ArchiveBase'
import {LIVE_TYPE} from './helper/def'

export default {
  name: "ArchiveLivePaid",
  components: {
    ArchiveBase
  },
  data() {
    return {
      liveType: LIVE_TYPE.PAID
    }
  },
  props: {},
  computed: {},
  watch: {},
  mounted() {},
  async created() {},
  updated() {},
  async destroyed() {},
  methods: {}
};
</script>
